import React from 'react';
import { Modal, ModalHeader, ModalBody, Input, Label, Button } from 'reactstrap';

const VersionModal = ({ isOpen, toggle, onCreateVersion, versionNote, setVersionNote }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Yeni Versiyon Oluştur</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <Label className="form-label">Versiyon Notu</Label>
          <Input
            type="textarea"
            value={versionNote}
            onChange={(e) => setVersionNote(e.target.value)}
            placeholder="Versiyonda yapılan değişiklikleri açıklayın..."
            rows="4"
          />
        </div>
        <div className="text-end">
          <Button color="light" onClick={toggle} className="me-2">
            İptal
          </Button>
          <Button
            color="primary"
            onClick={onCreateVersion}
            disabled={!versionNote.trim()}
          >
            Versiyon Oluştur
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VersionModal;